<template>
    <div>
        <FormVueSelect append-to-body hide-errors multiple :searchable="false" v-model="selectedValues" max-height="200" class="!tw-h-fit"
            :options="shipping_methods" option-value="value" :label="$t('fields.shipping_method')" :error="errors.shipping_method &&
                $t('errors.' + errors.shipping_method, {
                    field: $t('fields.shipping_method'),
                })
                ">
            <template v-slot:option="{ option }">
                <p class="tw-p-2 tw-rounded tw-text-xs tw-px-4">{{
                    option.label }}</p>
            </template>
            <template v-slot:selected-option-container="{ params }">
                <div class="vs__selected tw-text-xs tw-py-0 tw-px-2"  @click="removeValue(params.option.value)">{{ params.option.label
                    }}</div>
            </template>
        </FormVueSelect>
    </div>
</template>

<script setup>
import FormVueSelect from "@/components/form/FormVueSelect";
import { computed, ref, watch, inject } from 'vue';
import { useI18n } from "vue-i18n";

const i18n = useI18n();
const updateFilters = inject('update:filters')
const filters = inject('filters')
const shipping_methods = computed(() => [
    {
        label: i18n.t('sourcing.shipping_methods.air'),
        value: 'air',
    },
    {
        label: i18n.t('sourcing.shipping_methods.sea'),
        value: 'sea',
    },
    {
        label: i18n.t('sourcing.shipping_methods.land'),
        value: 'land',
    }
])

const errors = ref({})
const selectedValues = ref(filters.value.shipping_method || []);
watch(() => selectedValues.value, () => {
    const newFilters = {
        ...filters.value,
        shipping_method: selectedValues.value,
    }

    updateFilters(newFilters)
})

const removeValue = value => {
    selectedValues.value = selectedValues.value.filter(v => v != value)
}

</script>

<style></style>